<template>
  <div>
    <div v-if="model===false">
      <div class="totalmakeHole" ref="total">
        <div class="topback"  :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)' ,position:'fixed'}">
          <headtip @showDialog="showPartner"></headtip>
        </div>
        <div class="makeHole1">
          <div class="talk_con">
            <div>
              <div class="title">服务反馈</div>
              <div class="title1">尊敬的客户：</div>
              <div class="title2" >
                您好！为了给您提供更好的网上体验，我们诚挚邀请您<span  style="color: rgb(255, 100, 0);font-weight: bold">反馈使用感受</span>，您留下的每个意见或建议都是我们不断改进的动力！我们会针对您的反馈不断优化网页，为您提供更加愉悦的服务体验！感谢您的支持！</div>
            </div>
            <div class="form-container">
              <el-row style="width: 100%">
                <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="32%">
                  <el-form-item style="margin-bottom: 50px;background-color: #e8edf5" label="您在上网过程中所遇到的问题类型" prop="type">
                    <div style="margin-left: 15px">
                      <el-radio v-model="ruleForm.type" label="1">程序bug</el-radio>
                      <el-radio v-model="ruleForm.type" label="2">功能建议 </el-radio>
                      <el-radio v-model="ruleForm.type" label="3">内容意见</el-radio>
                      <el-radio v-model="ruleForm.type" label="4">其他</el-radio></div>
                  </el-form-item>

                  <el-form-item  label="您的意见或建议" prop="suggestion">

                    <el-input v-model="ruleForm.suggestion" placeholder="描述您所遇到的问题或建议，如需联系客服可使用客户服务-在线咨询，谢谢! (15-200字)"></el-input>

                  </el-form-item>

                  <el-form-item  style="background-color: #e8edf5"  label="文件截图或文件上传" prop="attachment">
                    <el-upload
                        ref="field102"
                        :file-list="fileList"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        :before-upload="fileUpload"
                        class="inputStyle"
                        :show-file-list="true"
                        action="/file/upload"
                        multiple>
                      <div style="display: flex;margin-left: 15px">
                        <div><i class="el-icon-upload"></i></div>
                        <div class="el-upload__text" ><em>
                          （如有，可点击上传）</em></div>
                      </div>
                    </el-upload>
                  </el-form-item>

                  <el-form-item label="您的姓名" prop="user_name">
                    <el-input v-model="ruleForm.user_name" placeholder="请填写您的联系姓名"></el-input>
                  </el-form-item>
                  <el-form-item style="background-color: #e8edf5"  label="联系方式（电话/邮箱）" prop="mail">
                    <el-input v-model="ruleForm.mail" placeholder="欢迎您留下联系方式，此信息仅作为内部参考资料，严格保密"></el-input>
                  </el-form-item>

                  <el-form-item style="text-align: center">

                  </el-form-item>
                </el-form>
              </el-row>
              <div style="text-align: center" class="submitStyle" @click="submitForm(ruleForm)">立即提交
              </div>
            </div>
          </div>


          <bottomTip></bottomTip>
        </div>
        <successTip
            :dialogVisible="dialog"
            @hideDialog="hidesuccess"
        ></successTip>
        <partnerTip
            :dialogVisible="dialogconsult"
            @hideDialog="hide"
        ></partnerTip>
        <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>

      </div>
      <div v-if="showModal" @click="closeModal" class="modal-overlay">
        <div class="modal-content" >
          <img :src="largeSrc" alt="Large Image" class="large-image">
        </div>
      </div>
    </div>
    <div v-else>
      <div class="totalmakeHoleModel">
        <div>
          <div class="screen1">
            <headtip @showDialog="showPartner"></headtip>
          </div>
          <div class="makeHole1">
            <div class="talk_con">
              <div>
                <div class="title">服务反馈</div>
                <div class="title1">尊敬的客户：</div>
                <div class="title2" >
                  您好！为了给您提供更好的网上体验，我们诚挚邀请您<span  style="color: rgb(255, 100, 0);font-weight: bold">反馈使用感受</span>，您留下的每个意见或建议都是我们不断改进的动力！我们会针对您的反馈不断优化网页，为您提供更加愉悦的服务体验！感谢您的支持！</div>
              </div>
              <div class="form-container">
                <el-row style="width: 100%">
                  <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="32%">
                    <el-form-item style="margin-bottom: 50px;background-color: #e8edf5" label="您在上网过程中所遇到的问题类型" prop="type">
                      <div style="margin-left: 15px">
                        <el-radio v-model="ruleForm.type" label="1">程序bug</el-radio>
                        <el-radio v-model="ruleForm.type" label="2">功能建议 </el-radio>
                        <el-radio v-model="ruleForm.type" label="3">内容意见</el-radio>
                        <el-radio v-model="ruleForm.type" label="4">其他</el-radio></div>
                    </el-form-item>

                    <el-form-item  label="您的意见或建议" prop="suggestion">

                      <el-input   :rows="3" type="textarea" v-model="ruleForm.suggestion" placeholder="描述您所遇到的问题或建议，如需联系客服可使用客户服务-在线咨询，谢谢! (15-200字)"></el-input>

                    </el-form-item>

                    <el-form-item  style="background-color: #e8edf5"  label="文件截图或文件上传" prop="attachment">
                      <el-upload
                          ref="field102"
                          :file-list="fileList"
                          :on-preview="handlePreview"
                          :on-remove="handleRemove"
                          :before-remove="beforeRemove"
                          :before-upload="fileUpload"
                          class="inputStyle"
                          :show-file-list="true"
                          action="/file/upload"
                          multiple>
                        <div style="display: flex;margin-left: 15px">
                          <div><i class="el-icon-upload"></i></div>
                          <div class="el-upload__text" ><em>
                            （如有，可点击上传）</em></div>
                        </div>
                      </el-upload>
                    </el-form-item>

                    <el-form-item label="您的姓名" prop="user_name">
                      <el-input v-model="ruleForm.user_name" placeholder="请填写您的联系姓名"></el-input>
                    </el-form-item>
                    <el-form-item style="background-color: #e8edf5"  label="联系方式（电话/邮箱）" prop="mail">
                      <el-input  :rows="3" type="textarea"  v-model="ruleForm.mail" placeholder="欢迎您留下联系方式，此信息仅作为内部参考资料，严格保密"></el-input>
                    </el-form-item>

                    <el-form-item style="text-align: center">

                    </el-form-item>
                  </el-form>
                </el-row>
                <div style="text-align: center" class="submitStyle" @click="submitForm(ruleForm)">立即提交
                </div>
              </div>
            </div>

          </div>
          <div ref="bottom">
            <bottomTip></bottomTip>
          </div>

        </div>
        <partnerTip
            :dialogVisible="dialogconsult"
            @hideDialog="hide"
        ></partnerTip>
        <consultTip
            :dialogVisible="dialogVisible"
            :thisTitle="title"
            @hideDialog="hideDialog"
        ></consultTip>
        <successTip
            :dialogVisible="dialog"
            @hideDialog="hidesuccess"
        ></successTip>
      </div>
    </div>
  </div>



</template>


<script>

import headtip from "@/views/headTip.vue";
import bottomTip from "@/views/bottomTip.vue";
import consultTip from "@/components/consultTip.vue";
import PartnerTip from "@/components/partnerTip.vue";
import {shareUrl} from "@/utils/vxshare";
import successTip from "@/components/successTip.vue";
export default {

  name: "",

  props: [],

  components: {successTip, PartnerTip, consultTip, headtip,bottomTip},

  data() {
    return {
      changeVisable:1,
      showModal: false,
      largeSrc:'',
      title:'',
      pageTitle: '服务反馈-油气通GPT',
      pageDescription: '您好！为了给您提供更好的网上体验，我们诚挚邀请您反馈使用感受，您留下的每个意见或建议都是我们不断改进的动力！我们会针对您的反馈不断优化网页，为您提供更加愉悦的服务体验！感谢您的支持！',
      pageKeywords: '智慧油气，基础设施建设，智慧油气基础设施建设，井口一体化远传系统，远程调压解决方案，橇装机柜间整体解决方案，数字化抽油机控制柜，安迅智云，语音机器人助理，安迅数智，油气通GPT',
      model:false,
      scrollback:false,
      dialogconsult:false,
      dialog:false,
      dialogVisible:false,
      contentType: {
        phone: "",
        email: "",
        address: "",
      },
      field102Action: 'http://54.223.240.188:8787',
      fileList: [],
      ruleForm: {
        type: '',
        suggestion: '',
        attachment:'',
        user_name:'',
        mail:''
      },
      rules: {

        suggestion:[
          {required: true, message: '请输入您的意见或建议', trigger: 'blur'}
        ]

      }

    }

  },


  methods: {
    changeheadVisable(){
      if(this.changeVisable===1){
        this.changeVisable=0
      }
      else{
        this.changeVisable=1
      }
      console.log("父组件", this.changeVisable)
    },
    showDialog(type) {
      this.dialogVisible = type;
    },
    GetColumnContact() {
      this.$axios.get('/api/feedback/add', {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.token,
        }
      })
          .then((res) => {
            this.contentType = res.data;
          })
          .catch(() => {
          });
    },

    handleClose() {
      this.ruleForm.type =""
      this.ruleForm.suggestion =""
      this.ruleForm.attachment=""
      this.ruleForm.user_name=""
      this.ruleForm.mail=""
      // this.$emit('hideDialog')
    },
    submitForm(formName) {
      formName.consultUrl = window.location.href
      console.log(formName)
      if (formName.suggestion === "") {
        this.$message('请输入您的意见或建议');
      } else {
        this.$axios.post("/search/addWebFeedback",formName, {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token
          },
        })
            .then((res) => {
              if (res.data.code === 200) {
                this.dialog = true
                this.handleClose()
                // this.resetForm(formName)
              } else {
                this.$message('提交失败，请重新提交试试');
              }

            }).catch(error => {
          console.log(error)
        })

      }

      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     alert('submit!');
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    // 文件上传
    async fileUpload(file) {
      try {
        // 构建表单数据
        const formData = new FormData();
        formData.append('file', file);

        // 向后端发送文件到 /common/upload 接口
        const response = await this.$axios.post('/file/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        this.uploadedFileValue = response.data;
        console.log(response.data); // 打印响应数据到控制台
        this.ruleForm.attachment=response.data.msg
        // 返回 true 允许上传，false 禁止上传
        return true;
      } catch (error) {
        console.error('上传失败:', error);
        return false;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log("预览")
      console.log(file);
      // this.showModal = true;
      window.open(file.response.url)
      // this.largeSrc=file.response.url
    },

    beforeRemove(file, fileList) {
      console.log(fileList)
      return this.$confirm(`确定移除 ${ file.name }？`);
    },


    field102BeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2
      if (!isRightSize) {
        this.$message.error('文件大小超过 2MB')
      }
      return isRightSize
    },
    showModalTrue(item){
      this.showModal = true;
      console.log(item)
      this.largeSrc=item
    },
    closeModal() {
      this.showModal = false;
    },
    clickConsult(item){

      this.title=item
      this.dialogVisible = true;
      sessionStorage.setItem('title',item)
    },
    hide(){
      this.dialogconsult=false;
    },
    hidesuccess(){
      this.dialog=false;
    },
    hideDialog() {
      this.dialogVisible = false;
    },
    showPartner(){
      this.dialogconsult=true;
    },
    skipp3() {
      const element = this.$refs.bottom;
      const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);

      this.$nextTick(() => {
        this.$refs.totalModel.scrollTop = rect
      });
    },    setMetaTags() {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', this.pageDescription);
      }

      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', this.pageKeywords);
      }
    },
    handleScroll() {
      if(this.model===false){
        this.scrollHeight = this.$refs.total.scrollTop;
      }
      else{
        this.scrollHeight = this.$refs.totalModel.scrollTop;
      }

      if( this.scrollHeight<100){
        this.scrollTrue=true
      }
      else{
        this.scrollTrue=false
      }
      if( this.scrollHeight<50){
        this.scrollback=false
      }
      else{
        this.scrollback=true
      }
      console.log("gaodu",this.scrollHeight<100)
    },
  },
  beforeDestroy() {

    this.$refs.total.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.$refs.total.addEventListener('scroll', this.handleScroll);
    document.title=this.pageTitle;
    this.setMetaTags();
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

// Log the values1731 809   1653 834   1912 932
    console.log("Screen Width: ", screenWidth);
    console.log("Screen Height: ", screenHeight);
    if(screenWidth<=700){
      this.model=true
    }else{
      this.model=false
    }

    if (localStorage.getItem("skip") === '3') {
      this.$nextTick(() => {
        this.skipp3();
      });
    }
  },
  created() {
    localStorage.setItem("home",0)
    let url = window.location.href
    // let url = 'https://oilgasinfoai.com/?language=zh'
    setTimeout(() => {
      //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
      let shareData = {
        url: url,
        pageTitle: '服务反馈-油气通GPT',
        pageDescription: '您好！为了给您提供更好的网上体验，我们诚挚邀请您反馈使用感受，您留下的每个意见或建议都是我们不断改进的动力！我们会针对您的反馈不断优化网页，为您提供更加愉悦的服务体验！感谢您的支持！',
        pageKeywords: '服务反馈，油气通GPT',

      };
      shareUrl(shareData);
    }, 1000);
  },
}

</script>


<style type="text/scss" lang="scss" scoped>
.totalmakeHole{
  background: white;
  overflow-x: hidden;
  width: 99vw;
  height: auto;
  position: relative;
  //overflow-y: hidden;
  .topback{
    position: fixed;
    z-index:1;
    width: 100vw;
    padding: 0 0 0 2.86077411900635vw;
  }
  .makeHole1 {
    //z-index:: 3;
    position: relative;
    width: 100%;
    height: fit-content;

    ::v-deep .el-upload-list__item:first-child{
      margin:0 0 0 -1.5px;
      padding-left: 10px;
      border-left: 2px solid white;
    }
    ::v-deep .el-upload-list__item{
      margin:0 0 0 -1.5px;
      padding-left: 10px;
      border-left: 2px solid white;
      border-radius: 0;
    }
    ::v-deep .el-form-item {
      margin-bottom: 0 !important;
      border-top:2px solid white;
    }
    ::v-deep .el-form-item__error {
      left: 15px !important;
      font-size: 14px;
      top: 50%;
      transform: translateY(-50%);
    }
    ::v-deep {
      .el-dialog__body {
        padding: 30px 50px 30px 35px;
        //color: #606266;
        font-size: 14px;
        word-break: break-all;
      }

      .el-dialog__header {
        padding: 10px;
        .el-dialog__title {
          font-weight: bold;
          font-size: 14px;
        }
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #2F6EFF;;
        border: #2F6EFF 1px solid;
        border-radius: 50%;
      }
     .el-form-item__content{
        font-size: 0.9vw;
      }
      .el-input__inner {
        font-size: 0.9vw;
        white-space: pre-line;
        font-family: Sarial, sans-serif, "Microsoft Yahei";

        border-radius: 5px !important;
        border: none !important;
        height: 30px;
        background-color: transparent;

      }

      .el-textarea {
        line-height: 35px;
        border-radius: 5px !important;
        //border: 1px solid #9b9a9a !important;
        position: relative;
        font-size: 14px;
      } .el-textarea__inner {

          font-size: 14px;
          font-family: Sarial, sans-serif, "Microsoft Yahei";

        }

      .el-form-item__label {
        font-size: 0.9vw;
        text-align: center;
        border-right: 2px solid white;
      }
      .el-avatar, .el-cascader-panel, .el-radio, .el-radio--medium.is-bordered .el-radio__label, .el-radio__label{
        font-size: 0.9vw;
      }

      .el-button {
        width: 150px;
        height: 45px;
        line-height: 35px;
        border-radius: 5px;
        text-align: center;
        cursor: pointer;
        color: #2F6EFF;
        padding: 0;

        a {
          display: block;
        }
      }

      .el-button--primary {
        border: 1px solid #2F6EFF;
        background: #2F6EFF;
        color: #fff;
      }

    }
    .talk_con {
      height: auto;
      width: 65vw;
      padding:0vh 5vw 3vh 5vw;
      margin: 10vh auto;
      border-radius: 5px;
      //box-shadow: 0 2px 4px 0 rgb(100, 98, 98);
      background-color: #fff;
      .title{
        margin:0 auto 3vh auto;
        text-align: center;
        font-size:1.5vw;
        color:#333333;
        font-weight: bold
      }
      .title1{
        margin:0 auto 2vh auto;
        text-align: left;
        font-size:1vw;
        color:#333333;
        font-weight: bold
      }
      .title2{
        margin:0 auto 4vh auto;
        text-align: left;
        line-height: 4vh;
        font-size:0.9vw;
        color:#333333;
        font-weight: normal;
      }

    }
    .submitStyle{
      cursor: pointer;
      width: 100%;
      height: 35px;
      display: flex;
      justify-content:  center;;
      align-items: center;
      font-size: 0.9vw;
      font-weight: bold;
      background-color: #cdd9ea
    }
    .submitStyle:hover{
      //font-weight: bold;
      background-color: #efdec3
    }
  }

}
.modal-overlay {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height:100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  .large-image {
    max-width: 100%;
    max-height: 80vh;
  }
}
.totalmakeHoleModel{
  //background: #ebf1fd;
  overflow-x: hidden;
  width: 100vw;
  height: auto;
  position: relative;
  .screen1 {
    //z-index:: 3;
    position: relative;
    width: 100%;
    height: 0;
    padding: 2.84301606922126vh 2.86077411900635vw 2.84301606922126vh 2.86077411900635vw;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: transparent;

    /* Add any additional styling as needed */
  }
  .makeHole1 {
    //z-index:: 3;
    position: relative;
    width: 100%;
    height: fit-content;
    .talk_con {
      height: auto;
      width:90%;
      padding:15px;
      margin: 5px auto 15px auto;
      border-radius: 5px;
      //box-shadow: 0 2px 4px 0 rgb(100, 98, 98);
      //background-color: #fff;
      .title{
        margin:0 auto 20px auto;
        text-align: center;
        font-size:16px;
        color:#333333;
        font-weight: bold
      }
      .title1{
        margin:0 auto 10px auto;
        text-align: left;
        font-size:16px;
        color:#333333;
        font-weight: bold
      }
      .title2{
        margin:0 auto 15px auto;
        text-align: left;
        line-height: 26px;
        font-size:14px;
        color:#333333;
        font-weight: normal;
      }

    }
    .submitStyle{
      cursor: pointer;
      width: 100%;
      height: 35px;
      display: flex;
      justify-content:  center;;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      background-color: #e8edf5
    }
    .submitStyle:hover{
      //font-weight: bold;
      background-color: #efdec3
    } ::v-deep .el-form-item {
        margin-bottom: 0 !important;
        border-top:2px solid white;
      }
    ::v-deep .el-form-item__error {
      left: 15px !important;
      font-size: 14px;
      top: 50%;
      transform: translateY(-50%);
    }


    ::v-deep {
      .el-dialog__body {
        padding: 30px 50px 30px 35px;
        //color: #606266;
        font-size: 14px;
        word-break: break-all;
      }

      .el-dialog__header {
        .el-dialog__title {
          font-weight: bold;
          font-size: 14px;
        }
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #2F6EFF;;
        border: #2F6EFF 1px solid;
        border-radius: 50%;
      }

      .el-input__inner {
        font-size: 12px;
        font-family: Sarial, sans-serif, "Microsoft Yahei";

        border-radius: 5px !important;
        border: none !important;
        background-color: transparent;

      }

      .el-textarea {
        line-height: 35px;
        border-radius: 5px !important;
        //border: 1px solid #9b9a9a !important;
        position: relative;
        font-size: 14px;
      }

      .el-textarea__inner {

        background-color: #f5f5f5;
        font-size: 12px;
        border-radius: 0;
        border: none;
        font-family: Sarial, sans-serif, "Microsoft Yahei";

      }
      .el-form-item__content{
        font-size: 12px;
      }
      .el-form-item__label {
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        border-right: 2px solid white;
        white-space: pre-line;
        padding: 15px 5px;
        /*text-align-last: justify;*/
        /*text-align:justify;*/
        //margin-top:-4px;
        //line-height:25px;
        //text-justify:distribute-all-lines;

      }

      .el-button {
        width: 150px;
        height: 45px;
        line-height: 35px;
        border-radius: 5px;
        text-align: center;
        cursor: pointer;
        color: #2F6EFF;
        padding: 0;

        a {
          display: block;
        }
      }

      .el-button--primary {
        border: 1px solid #2F6EFF;
        background: #2F6EFF;
        color: #fff;
      }
    }
  }
  ::v-deep .el-upload-list__item:first-child{
    margin:0 0 0 -1.5px;
    padding-left: 10px;
    border-left: 2px solid white;
  }
  ::v-deep .el-radio__label{
    padding-left: 5px;
    font-size: 12px;
    margin-right: 15px;
  }
  ::v-deep .el-radio{
    margin-right: 0;
  }
  ::v-deep .el-upload-list__item{
    margin:0 0 0 -1.5px;
    padding-left: 10px;
    border-left: 2px solid white;
    border-radius: 0;
  }
}
</style>
